import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import { Link } from "react-router-dom";
import { FiSearch, FiPackage } from "react-icons/fi";

function SearchCanvas({ isOpen, searchText, setSearchText }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!searchText) {
      setProducts([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchProducts(1, searchText);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchTxt) => {
    setLoading(true);
    try {
      if (searchTxt) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchTxt,
        });

        if (res.code === 200) {
          const { products: fetchedProducts } = res.data;
          setProducts((prev) => (pageNum === 1 ? fetchedProducts : [...prev, ...fetchedProducts]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔥 FIXED: Agar overlay/canvas close hai tabhi rukega. Blank text par dropdown ka dabba dikhega!
  if (!isOpen) return null;

  return (
    <div className="search-dropdown-funky">
      {/* 1. INITIAL BLANK STATE */}
      {!searchText && (
        <div className="search-hint-state p-4 text-center">
          <FiSearch className="hint-icon animate-pulse mb-2" size={24} />
          <p className="mb-0 fw-medium">Type something to search premium drops... ⚡</p>
        </div>
      )}

      {/* 2. LOADING STATE */}
      {searchText && loading && (
        <div className="search-loading-state p-3 d-flex align-items-center gap-2">
          <div className="spinner-border spinner-border-sm text-dark" role="status"></div>
          <span className="fw-bold">Hunting for products...</span>
        </div>
      )}

      {/* 3. NO PRODUCTS FOUND */}
      {searchText && !loading && products.length === 0 && (
        <div className="search-empty-state p-4 text-center">
          <FiPackage className="hint-icon mb-2" size={24} />
          <p className="mb-0 fw-bold">No items found matching "{searchText}"</p>
        </div>
      )}

      {/* 4. PRODUCTS LIST MAPPING */}
      {searchText && products.length > 0 && (
        <div className="search-results-list">
          <div className="results-header-tag">FOUND {products.length} MATCHES</div>
          
          {products.map((product) => {
            const image = product?.thumbnail || product?.images?.[0];
            const price = product?.variants?.[0]?.price || product?.price;

            return (
              <Link
                to={`/shop/${product.slug}`}
                className="search-item-row-link"
                key={product._id}
                onClick={() => setSearchText("")} // Item click hote hi text reset taaki agali baar fresh khule
              >
                {/* Fixed Portrait Dimensions Box 72x94 */}
                <div className="search-img-frame-72x94">
                  <img src={image} alt={product.title} />
                </div>
                
                <div className="search-item-meta-info">
                  <h6 className="search-item-title-funky">{product.title}</h6>
                  <span className="search-item-price-tag">₹{price}/-</span>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SearchCanvas;